import React from 'react';
export default (function (_ref) {
  var lines = _ref.lines;
  return (
    /*#__PURE__*/
    React.createElement("span", {
      className: "math",
      dangerouslySetInnerHTML: {
        __html: lines.join('\n')
      }
    })
  );
});